import {useEffect, useState, useCallback, useMemo} from 'react';

import {OnlineStatusIcon} from 'components/OnlineStatusIcon';
import {useIsChanged} from 'hooks';
import {AgentSession, AnyParticipant, OnlineSession, SessionAppointment} from 'interfaces';
import {OnlineStatus} from 'types';
import {sessionUtils} from 'utils';

type Props = {
    session: AgentSession | OnlineSession | SessionAppointment;
    participant: AnyParticipant
    reverseAlign?: boolean;
    onChange?: (status: OnlineStatus) => void;
};

export const ParticipantOnlineStatusIcon: React.FC<Props> = ({session, participant, reverseAlign, onChange}) => {
    const [currentDate, setCurrentDate] = useState<Date>(new Date());

    const getNow = useCallback(() => new Date(), []);
    const lastActivityDate = useMemo(() =>
        sessionUtils.getParticipantLastActivity(session as AgentSession | OnlineSession, participant?.id), [session, participant]);

    const onlineStatus = useMemo(() =>
        sessionUtils.getOnlineStatus(session, currentDate, participant, lastActivityDate),
    [currentDate, lastActivityDate, participant, session]);

    const onlineStatusChanged = useIsChanged(onlineStatus);

    useEffect(() => {
        setCurrentDate(getNow());

        const interval = window.setInterval(() => {
            setCurrentDate(getNow());
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [getNow]);

    useEffect(() => {
        if (onlineStatusChanged) {
            onChange?.(onlineStatus);
        }
    }, [onChange, onlineStatus, onlineStatusChanged]);

    return <OnlineStatusIcon status={onlineStatus} reverseAlign={reverseAlign} />;
};